const name = 'OutIn';
const properties = {
    defaultDuration: 0.7,
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        stagger: {
            type: 'number',
            default: 0,
        },
    },
};
/**
 * Fade out an element and after it disappears fade in the next element.
 */
function transition(kit, sourceElements, destElements, duration, delay, { stagger = 0, sourceEase = 'Strong.easeOut', destEase = 'Strong.easeIn', ...params } = {}) {
    const sequence = kit.sequence(params);
    sequence.add([
        kit.animate('BaseFade', sourceElements, duration, delay, {
            from: { opacity: 1 },
            to: { opacity: 0 },
            ease: sourceEase,
            stagger,
        }),
        kit.animate('BaseFade', destElements, duration, delay, {
            from: { opacity: 0 },
            to: { opacity: 1 },
            ease: destEase,
            stagger,
        }),
    ]);
    return sequence.get();
}
export { name, properties, transition };
//# sourceMappingURL=outIn.js.map